module.exports = __webpack_public_path__ + "static/media/30OIOS7.67998366.jpg";